// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"329":"148d96c9","2869":"72c535f7","3511":"8a465f36","5344":"72c535f7","9636":"72c535f7"}[chunkId] + ".chunk.css";
};